<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title" style="width: 100%">
        <button onclick="javascript:location.href='../Employees/EmployeeLeavesRecord'" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row" style="margin-top: 10px">
        <div class="col-md-12">
          <div class="table-responsive">
            <table id="leavesRecordTable" class="table table-bordered table-striped table-color table-sm">
              <thead class="bg-info">
                <tr>
                  <th>Sr.</th>
                  <th>Employee Name</th>
                  <th>Leave Type</th>
                  <th>Date From</th>
                  <th>Date To</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in leavesRecord">
                  <td>{{ind+1}}</td>
                  <td>{{item.Name}}</td>
                  <td>{{item.LeaveTypeName}}</td>
                  <td>{{item.DateFrom}}</td>
                  <td>{{item.DateTo}}</td>
                  <td>
                    <button class="btn btn-info" v-on:click="edit(item.EmployeeLeaveRecordID)">Edit</button>
                    <button class="btn btn-success" v-on:click="viewFile(item.Attachment)">View Attachment</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        leavesRecord: [],
      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },

    updated: function () { 
        $('#leavesRecordTable').DataTable(); 
    },

    methods: {
      pageLoad: function () {
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/loadLeavesRecord')
          .then(function (pl) {
            endReq();
            vm.leavesRecord = pl.data["lst"];
          })
      },

      edit(id) {
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/EditLeavesRecord?ID=' + id)
          .then(function (pl) {
            if (pl.data.status) { 
              window.open("../Employees/EmployeeLeavesRecord", "_blank");
              endReq();
            }
          })
      },

      viewFile(name) {
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/viewLeaveAttachment?name=' + name)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              if (res.data.format == '.pdf') {
                var pdfString = res.data.file.split(',')[1];
                let pdfWindow = window.open("");
                pdfWindow.document.write(
                  "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                  encodeURI(pdfString) + "'></iframe>"
                );
              }
              else {
                var newTab = window.open();
                newTab.document.body.innerHTML = '<img src="' + res.data.file + '" >';
              }
            }
            else
              toastr.info(res.data.msg);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    }
  })

</script>

<style>
  table thead tr th {
    background-color: #17a2b8;
    color: white;
  }

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hr/employeeLeavesRecordIndex.vue